// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HUqb","option":"styles_option__3YIS6","selected":"styles_selected__2Xpal"};